import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";

export default function MenuButton({ children, buttonid }) {
  return (
    <div className="dropstart">
      <button
        className="btn bg-white border border-1 float-end"
        type="button"
        id={buttonid}
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <FontAwesomeIcon icon={faEllipsisV} />
      </button>
      <ul
        className="dropdown-menu dropdown-menu-end"
        aria-labelledby={buttonid}
      >
        {children}
      </ul>
    </div>
  );
}
